import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

import { TranslocoService } from '@jsverse/transloco';

import { ProjectCollection } from 'app/modules/project/models/project-collection.model';
import { SemantriaAccount } from 'app/providers/bridge-api/account.service';
import { FieldStatisticsPayload } from 'app/providers/field-statistics.service';
import { FieldService } from 'app/providers/storage-api/field.service';
import { CalculationRequest } from 'app/providers/storage-api/predictive.service';
import {
  injectComponentTelemetryService,
  EnableComponentTelemetry,
  EnableClassTelemetry,
} from 'app/services/otel.service';

import { DriverAnalysisStep } from './../driver-analysis-dialog.component';

@EnableClassTelemetry()
@Component({
  selector: 'app-hierarchy-step',
  templateUrl: './hierarchy-step.component.html',
  styleUrls: ['./hierarchy-step.component.scss'],
  standalone: false,
})
export class HierarchyStepComponent implements DriverAnalysisStep, OnInit {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();
  @Input() data: Partial<CalculationRequest>;
  @Input() collection: ProjectCollection;
  @Input() fieldStatisticsPayload: FieldStatisticsPayload;

  @Output() onValidityChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  isLoading = true;

  availableHierarchyFields: { label: string; value: string }[] = [];

  constructor(
    private semantriaAccount: SemantriaAccount,
    private translocoService: TranslocoService
  ) {}

  async ngOnInit() {
    this.onValidityChange.emit(!!this.data.breakdownColumn);

    const account = await this.semantriaAccount.sub.latest();

    const breakdownMin = account.storageLimits['DRIVER_ANALYSIS_BREAKDOWN_CARDINALITY_MIN'] || 1;
    const breakdownMax = account.storageLimits['DRIVER_ANALYSIS_BREAKDOWN_CARDINALITY_MAX'] || 10;

    this.availableHierarchyFields = Object.entries(this.fieldStatisticsPayload.custom)
      .filter(
        ([key, value]) =>
          FieldService.isVisible(key) &&
          value.type === 'keyword' &&
          value.cardinality <= breakdownMax &&
          value.cardinality >= breakdownMin
      )
      .map(([key]) => ({
        value: key,
        label: this.getLongLabel(key),
      }))
      .sort((a, b) => a.label.localeCompare(b.label));

    this.availableHierarchyFields.splice(0, 0, {
      value: 'No Hierarchy',
      label: this.translocoService.translate('driver-analysis-dialog.hierarchy-step.no-hierarchy'),
    });
    this.isLoading = false;
  }

  public getLongLabel(field: string): string {
    return FieldService.getFieldLongName(field);
  }
}
